'use client';

import React from 'react';

export default function MaintenancePage() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#0a0a0a] relative overflow-hidden font-outfit">
      {/* Background Gradients */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-red-500/20 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-orange-500/10 rounded-full blur-[120px] animate-pulse delay-1000" />

      <div className="relative z-10 px-6 text-center max-w-2xl mx-auto">
        <div className="mb-8 relative inline-block">
            <h1 className="text-6xl md:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400 tracking-tight">
              Closed
            </h1>
        </div>

        <div className="space-y-6 backdrop-blur-xl bg-white/5 p-8 md:p-12 rounded-3xl border border-white/10 shadow-2xl">
          <h2 className="text-2xl md:text-3xl font-semibold text-white">
            We Are Permanently Closed
          </h2>
          
          <p className="text-lg text-gray-400 leading-relaxed">
            It is with a heavy heart that we announce the permanent closure of R&R Equipment Rentals. 
          </p>
          
          <p className="text-lg text-gray-400 leading-relaxed">
            We would like to extend our deepest gratitude to all our customers for your trust and support throughout our journey. It has been a privilege to serve you.
          </p>

          <div className="pt-6 border-t border-white/10 mt-8">
            <p className="text-sm text-gray-500">
              &copy; {new Date().getFullYear()} R&R Equipment Rentals. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
